import templateUrl from './schedule-event-detail-modal.component.html';
import { ScheduleEventService } from '../../../core/services';
import { UtilityService } from '../../../core/services/utility.service';

export const ScheduleEventDetailModalComponent = {
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    templateUrl,
    controller: class ScheduleEventDetailModalController {
        constructor(private scheduleEventService: ScheduleEventService, private utilityService: UtilityService,
            private divisionService) {
            'ngInject'
        }

        resolve: any;
        close: any;
        dismiss: any;
        UseRSSchedule: boolean;

        $onInit() {
            this.refreshScreen();
        }

        refreshScreen() {
            return this.divisionService.retrieveDivision(this.resolve.scheduleEvent.DivisionID)
                .then(division => {
                    this.UseRSSchedule = division.UseRSSchedule;
                });
        }

        handleSave() {
            this.utilityService.showLoading();
            (() => {
                const scheduleEvent = this.resolve.scheduleEvent;
                const command = {
                    DivisionID: scheduleEvent.DivisionID,
                    StartDate: scheduleEvent.StartDate,
                    EndDate: scheduleEvent.EndDate,
                    EventHostID: scheduleEvent.EventHost.EventHostID,
                    EventSales: scheduleEvent.ScheduleEventSales
                };
                if (scheduleEvent.ScheduleEventID) {
                    return this.scheduleEventService
                        .updateScheduleEventAdditionalHours(scheduleEvent.ScheduleEventID, command);
                }
            })()
                .then(() => {
                    this.close({ $value: this.resolve.scheduleEvent });
                })
                .catch((ex) => {
                    alert("Saving event host failed: " + (ex.statusText || ex));
                })
                .then(() => {
                    this.utilityService.hideLoading();
                });
        }

        mapHoursOfOperation(hoursOfOperations) {
            return hoursOfOperations.reduce((operations, operation) => {
                const activeDays = operation.WeekDays.filter(p => p.value);
                activeDays.forEach(day => {
                    day.OpeningTime = operation.OpeningTime.toString("HH:mm:ss");
                    day.ClosingTime = operation.ClosingTime.toString("HH:mm:ss")
                });
                return operations.concat(activeDays)
            }, []);
        }
    }
};
